import React, { Fragment, useEffect, useState } from 'react';
import { Row, Col, Table, Badge } from 'reactstrap';
import { getPlanDataById } from '../../../../../api';


const MedicalCover = ({ data }) => {

    const medical_cover = data?.medical_cover;

    return (
        <Fragment>
            <Row className='mt-4'>
                <Col sm="12" >
                    <Table>
                        {/* <tbody>
                            <tr>
                                <th>Cover</th>
                                <td className="text-right pr-5">{data.medical_cover?.cover || '-'}</td>
                            </tr>
                            <tr>
                                <th>Sub Limit</th>
                                <td className="text-right pr-5">{data.medical_cover?.sub_limit || '-'}</td>
                            </tr>
                            <tr>
                                <th>Remark</th>
                                <td className="text-right pr-5">{data.title || '-'}</td>
                            </tr>
                        </tbody> */}

                        <thead>
                            <tr>
                                <th>Service</th>
                                <th>Cover</th>
                                <th>Sub Limit</th>
                                <th>Deductible</th>
                                <th>Remark</th>
                            </tr>
                        </thead>
                        <tbody className="mtd-bg">
                            {medical_cover?.length > 0 ? (
                                medical_cover?.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item?.service?.title || '-'}</td>
                                        <td>{item?.cover || '-'}</td>
                                        <td>{item?.sub_limit || '-'}</td>
                                        <td>{item?.deductible || '-'}</td>
                                        <td>{item?.remark || '-'}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="3" className="text-center">No records found.</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </Fragment>
    );
};

export default MedicalCover;